import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { ExternalSystem } from '../../types/generated.types';
import { DateHelper } from '../../helpers/date.helper';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';
import { BaseModel } from '../../types/generated.types';

@Injectable({ providedIn: 'root' })
export class ExternalSystemsApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/external-systems`;
  }

  async getExternalSystems(): Promise<ExternalSystem[]> {
    const externalSystems = await this.get<ExternalSystem[]>('');
    externalSystems.forEach(e => ApiConversionHelper.convertExternalSystem(e));
    return externalSystems;
  }

  async getExternalSystemsList(): Promise<BaseModel[]> {
    return await this.get<BaseModel[]>('list');
  }

  async createExternalSystem(externalSystem: ExternalSystem): Promise<string> {
    return await this.postWithResult('', externalSystem);
  }

  async updateExternalSystem(externalSystem: ExternalSystem): Promise<void> {
    return await this.put('', externalSystem);
  }

  async setExternalSystemIsQuarantined(externalSystemId: string, isQuarantined: boolean, endOfQuarantine?: Date): Promise<void> {
    return await this.patch(`${externalSystemId}/is-quarantined`, { isQuarantined, endOfQuarantine: endOfQuarantine ? DateHelper.formatApiDateTime(endOfQuarantine) : undefined });
  }

  async deleteExternalSystem(externalSystem: ExternalSystem): Promise<void> {
    return await this.delete(`${externalSystem.id}`);
  }
}
